import * as types from './mutation-types'
import util from '@/util'

export const ActionSalvarFiltros = ({ commit }, { contexto, filtros }) => {
  if (util.valorVazio(contexto)) {
    return
  }
  commit(types.SET_FILTROS, { contexto, filtros })
}

export const ActionLimparFiltros = ({ commit }, contexto = null) => {
  commit(types.LIMPAR_FILTROS, contexto)
}

export const ActionSalvarOrdenacao = ({ commit }, { contexto, ordenacao }) => {
  if (util.valorVazio(contexto)) {
    return
  }
  commit(types.SET_ORDENACAO, { contexto, ordenacao })
}

export const ActionLimparOrdenacao = ({ commit }, contexto = null) => {
  commit(types.LIMPAR_ORDENACAO, contexto)
}
